module.exports = __webpack_public_path__ + "img/Adil.a9ceae58.jpeg";